import {
  convocatoria001,
  n1,
  n2,
  n3,
  n4,
  n5,
  convocatoria002,
  n6,
  n7,
  convocatoria003,
  n8,
  n9,
  n10,
  convocatoria004,
  n11,
  n12,
  n13,
  n14,
  n15,
  convocatoria005,
  n16,
  n17,
  convocatoria006,
  n18,
  n19,
  n20,
  n21,
} from "../../json/anioLicitaciones/2026/anioLicitacion2026";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CONVOCATORIA 01-2026":
      datosSeleccionados = convocatoria001;
      break;
    case "EA-913005999-N1-2026":
      datosSeleccionados = n1;
      break;
    case "EA-913005999-N2-2026":
      datosSeleccionados = n2;
      break;
    case "EA-913005999-N3-2026":
      datosSeleccionados = n3;
      break;
    case "EA-913005999-N4-2026":
      datosSeleccionados = n4;
      break;
    case "EA-913005999-N5-2026":
      datosSeleccionados = n5;
      break;
    case "CONVOCATORIA 02-2026":
      datosSeleccionados = convocatoria002;
      break;
    case "EA-913005999-N6-2026":
      datosSeleccionados = n6;
      break;
    case "EA-913005999-N7-2026":
      datosSeleccionados = n7;
      break;
    case "CONVOCATORIA 03-2026":
      datosSeleccionados = convocatoria003;
      break;
    case "EA-913005999-N8-2026":
      datosSeleccionados = n8;
      break;
    case "EA-913005999-N9-2026":
      datosSeleccionados = n9;
      break;
    case "EA-913005999-N10-2026":
      datosSeleccionados = n10;
      break;
    case "CONVOCATORIA 04-2026":
      datosSeleccionados = convocatoria004;
      break;
    case "EA-913005999-N11-2026":
      datosSeleccionados = n11;
      break;
    case "EA-913005999-N12-2026":
      datosSeleccionados = n12;
      break;
    case "EA-913005999-N13-2026":
      datosSeleccionados = n13;
      break;
    case "EA-913005999-N14-2026":
      datosSeleccionados = n14;
      break; 
    case "EA-913005999-N15-2026":
      datosSeleccionados = n15;
      break;
      case "CONVOCATORIA 05-2026":
      datosSeleccionados = convocatoria005;
      break;
      case "EA-913005999-N16-2026":
      datosSeleccionados = n16;
      break; 
      case "EA-913005999-N17-2026":
      datosSeleccionados = n17;
      break;
      case "CONVOCATORIA 06-2026":
      datosSeleccionados = convocatoria006;
      break;
      case "EA-913005999-N18-2026":
      datosSeleccionados = n18;
      break;
      case "EA-913005999-N19-2026":
      datosSeleccionados = n19;
      break;
      case "EA-913005999-N20-2026":
      datosSeleccionados = n20;
      break;
      case "EA-913005999-N21-2026":
      datosSeleccionados = n21;
      break;     
    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
